/**
 * Spacing Tokens
 * Consistent spacing patterns across the application
 * 
 * NOTE: For tab-to-content spacing, use TABS tokens from patterns/tabs.ts:
 * - TABS.contentTopLevel (mt-6) - after primary tabs
 * - TABS.contentNested (mt-4) - after secondary tabs  
 * - TABS.contentTertiary (mt-3) - after tertiary tabs
 */

export const SPACING = {
  // Page header - aligned with AccountLayout
  pageHeader: "space-y-1 sm:space-y-2",
  pageHeaderMargin: "mb-section-mobile sm:mb-section-tablet lg:mb-section",
  
  // Root containers - for content grouping INSIDE TabsContent panels
  pageContainer: "space-y-6",
  pageContainerLarge: "space-y-8",
  sectionContainer: "space-y-6",
  contentContainer: "space-y-4",
  
  // Dialog-specific spacing
  dialogContent: "space-y-6",
  dialogSection: "space-y-4",
  
  // Section with visual separator (bottom border + padding)
  sectionWithBorder: "pb-4 border-b border-border",
  
  // Section headers
  sectionHeader: "flex items-center gap-2 mb-4",
  sectionHeaderLarge: "flex items-center gap-3 mb-6",
  sectionHeaderGap: "gap-2",
  sectionSeparator: "my-6 border-t border-border",
  
  // Card internals
  cardHeaderCompact: "pb-2",
  cardHeaderStandard: "pb-3",
  cardContentCompact: "p-4",
  cardContentStandard: "p-6",
  cardPadding: "p-4",
  cardPaddingLarge: "p-6",
  cardContent: "p-4",
  
  // List items
  listItemGap: "gap-3",
  listItemGapCompact: "gap-2",
  listItemPadding: "p-3",
  
  // Pure margin tokens (safe for any context - no flex properties)
  marginBottom2: "mb-2",
  marginBottom4: "mb-4",
  marginBottom6: "mb-6",
  marginBottom8: "mb-8",
  marginTop2: "mt-2",
  marginTop4: "mt-4",
  marginTop6: "mt-6",
  
  // Stack spacing (vertical space between children - works without flex/grid)
  // Use these for space-y-* patterns instead of gap-* tokens
  stackXs: "space-y-1",
  stackSm: "space-y-2",
  stackMd: "space-y-3",
  stackLg: "space-y-4",
  stackXl: "space-y-6",
  stack2xl: "space-y-8",
  
  // Form field spacing (label to input gap)
  formFieldGap: "space-y-1.5",
  formFieldGapSm: "space-y-1",
  formFieldGapLg: "space-y-2",
} as const;

export type SpacingToken = keyof typeof SPACING;
